import React from 'react';
import { mockData } from '../mock';
import { Card, CardContent } from './ui/card';
import { Check } from 'lucide-react';

const Projects = () => {
  return (
    <section className="py-24 bg-[#F5F3ED]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-6 py-2 bg-white rounded-full text-[#1A3A2E] text-sm font-medium mb-6">
            Referenzen
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3A2E] mb-4">
            Ein Auszug unserer letzten Projekte
          </h2>
          <p className="text-lg text-[#1A3A2E]/70 max-w-4xl mx-auto">
            Sehen Sie sich ein paar unserer Projekte genauer an und bekommen Sie einen Eindruck davon, wie wir unseren Kunden helfen
          </p>
        </div>

        <div className="space-y-16">
          {mockData.projects.map((project, idx) => (
            <Card
              key={idx}
              className={`border-none shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-500 ${
                idx % 2 === 0 ? 'md:ml-0' : 'md:mr-0'
              }`}
            >
              <div className={`grid grid-cols-1 md:grid-cols-2 gap-0 ${
                idx % 2 === 0 ? '' : 'md:grid-flow-dense'
              }`}>
                <div className={`relative h-80 md:h-96 ${
                  idx % 2 === 0 ? '' : 'md:col-start-2'
                }`}>
                  <img
                    src={project.image}
                    alt={project.title}
                    className={`w-full h-full object-cover ${
                      idx === 0 ? 'object-top' : ''
                    }`}
                  />
                </div>
                <CardContent className={`p-8 md:p-10 flex flex-col justify-center bg-white ${
                  idx % 2 === 0 ? '' : 'md:col-start-1'
                }`}>
                  <h3 className="text-2xl md:text-3xl font-bold text-[#1A3A2E] mb-4">{project.title}</h3>
                  <p className="text-[#1A3A2E]/70 leading-relaxed mb-6 text-sm md:text-base">{project.description}</p>
                  <ul className="space-y-3">
                    {project.details.map((detail, detailIdx) => (
                      <li key={detailIdx} className="flex items-start space-x-3">
                        <Check className="w-5 h-5 text-[#1A3A2E] flex-shrink-0 mt-0.5" />
                        <span className="text-[#1A3A2E]/80 text-sm md:text-base">{detail}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;